<template>
    <div class="components-forms">
        <div class="forms-body">
            <el-form :model="personalForm" :rules="personalRules" ref="personalFormRef" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>姓名
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.name"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的姓名"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="logo">
                    <div class="content-item">
                        <div class="item-title">
                            <span>*</span>照片
                        </div>
                        <uploadVue @upload="personalLogoUpload" @remove="personalLogoRemove"></uploadVue>
                    </div>
                </el-form-item>
                <el-form-item prop="company">
                    <div class="content-item">
                        <div class="item-title">
                            公司名称
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.company"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入公司名称"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="title">
                    <div class="content-item">
                        <div class="item-title">
                            职务
                        </div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.title"
                                style="height: 36px"
                                maxlength="20"
                                placeholder="请输入您的职务"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="phone">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>手机号</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.phone"
                                style="height: 36px"
                                maxlength="11"
                                placeholder="请输入手机号"
                                show-word-limit
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="email">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>邮箱</div>
                        <div class="item-input">
                            <el-input
                                v-model="personalForm.email"
                                style="height: 36px"
                                placeholder="请输入邮箱"
                                type="text"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="topicTitle">
                    <div class="content-item">
                        <div class="item-title"><span>*</span>想听议题
                        </div>
                        <div class="item-input">
                            <el-select
                                v-model="personalForm.topicTitle"
                                placeholder="请输入或选择您想听到的议题"
                                filterable
                                remote
                                :remote-method="handleRemote"
                                :reserve-keyword="true"
                                @blur="handleBlur"
                                @focus="handleFocus"
                                :default-first-option="false"
                            >
                                <el-option
                                    v-for="item in AreaList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="isChecked">
                    <el-checkbox v-model="personalForm.isChecked">
                        <span>阅读并同意
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI%C2%A02025%C2%A0%E8%AE%AE%E9%A2%98%E5%BE%81%E9%9B%86%E6%8F%90%E4%BA%A4%E8%AF%B4%E6%98%8E.pdf"  target="_blank">《议题征集协议》</a>
                            <a style="color: #409eff;" href="https://cdn.isc.360.com/isc-cxo/ISC.AI_2025_topic_rule.pdf"  target="_blank">《活动规则》</a>
                        </span>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <div class="content-btn">
                        <el-button type="primary" @click="personalSubmitForm(personalFormRef)">提交</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <dialogVue ref="dialogRef" :data="posterInfo"></dialogVue>
    </div>
</template>
  
<script setup>
import { ref, onMounted, reactive } from 'vue';
import uploadVue from './myUpload.vue';
import dialogVue from './myDialog.vue';
import { submitForm } from '@/api/2025';
import { ElLoading, ElMessage} from 'element-plus';
import { topicList } from '@/mock/2026/topic.js';

let dialogRef = ref(null)

let posterInfo = ref({}) //海报信息

onMounted(() => {
    AreaList.value = topicList.map((item) => {
        return item.topic
    })
})

let AreaList = ref([])

let personalFormRef = ref(null)
const personalForm = reactive({
    name: '',
    logo: [],
    company: '',
    title: '',
    phone: '',
    email: '',
    topicTitle: '',
    isChecked: false,
    Orientation: 1
})

const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请填写手机号'));
    }
    if (!(/^1[3456789]\d{9}$/.test(value))) {
        return callback(new Error('手机号格式有误，请检查'));
    }
    return callback();
}
const checkEmail = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请填写邮箱'));
    }
    if (!(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))) {
        return callback(new Error('邮箱格式有误，请检查'));
    }
    return callback();
}
const checkRules = (rule, value, callback) => {
    if (value==false) {
        return callback(new Error('请阅读并同意协议和规则'));
    }
    return callback();
}
const personalRules = ref({
    logo: [
        { required: true, message: '请上传个人照片', trigger: 'upload' },
    ],
    name: [
        { required: true, message: '请输入您的姓名', trigger: 'blur' },
    ],
    phone: [
        { required: true, validator: checkPhone, trigger: 'blur' },
    ],
    email: [
        { required: true, validator: checkEmail, trigger: 'blur' },
    ],
    topicTitle: [
        { required: true, message: '请输入或选择您想听到的议题', trigger: 'blur' },
    ],
    isChecked: [
        { required: true, validator: checkRules, trigger: 'change' },
    ]
});

const personalLogoUpload = (file,orientation) => {
    personalForm.Orientation = orientation
    if(file[0]?.url){
        personalForm.logo[0] = file[0].url
        personalFormRef.value.clearValidate('logo')
    }
}
const personalLogoRemove = (file) => {
    personalForm.logo = []
}

const loadingInstance = ref(null)
const openLoading = () => {
    loadingInstance.value = ElLoading.service({
        lock: true,
        text: '正在生成您的专属海报，请稍候...',
        svg: `
            <path class="path" d="
            M 30 15
            L 28 17
            M 25.61 25.61
            A 15 15, 0, 0, 1, 15 30
            A 15 15, 0, 1, 1, 27.99 7.5
            L 15 15
            " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
        `,
        svgViewBox: "-10, -10, 50, 50",
        background: 'rgba(0, 0, 0, 0.8)',
        customClass: 'my-loading',
    })
}
const closeLoading = () => {
    loadingInstance.value.close()
}

//个人想听
let customizeTopicTitle = ref('')
const handleRemote = (query) => {
    customizeTopicTitle.value = query
    // 不筛选，options保持不变
}
const handleFocus = () => {
    customizeTopicTitle.value = ''
    personalForm.topicTitle = ''
}
const handleBlur = () => {
    // 失焦的时候，如果没有选择联想项，保存输入内容
    if (!AreaList.value.find(item => item === personalForm.topicTitle)) {
        personalForm.topicTitle = customizeTopicTitle.value
    }
}
const personalSubmitForm = async (formEl) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            let newData = JSON.parse(JSON.stringify(personalForm))
            newData.logo = newData.logo[0]
            newData.submissionMode = 'listen'
            newData.identityType = 'personal'
            newData.form_id = 1
            openLoading()
            return submitForm(newData).then(res => {
                if (res.data.msg == "SUCCESS") {
                    posterInfo.value = {
                        title: newData.topicTitle,
                        avatar: newData.logo,
                        name: newData.name,
                    }
                    setTimeout(() => {
                        dialogRef.value.openModel()
                        closeLoading()
                    },2000)
                }else{
                    closeLoading()
                    ElMessage.error(res.data.msg)
                }
            })
        } else {
            console.log(personalForm,'error submit!', fields)
        }
    })
}

</script>

<style lang="scss">
.my-loading .el-loading-text {
    font-size: 16px !important;
    font-weight: bold;
}
</style>
<style lang="scss" scoped>
.components-forms {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .forms-body{
    width: 800px;
    padding: 45px 60px;
    border: 1px solid rgb(211, 211, 211);
    // border-radius: 0px 0px 16px 16px;
    border-radius: 16px;
    background: rgb(255, 255, 255);
        .content-item{
            display: flex;
            flex-direction: column;
            width: 100%;
            .item-title{
                display: flex;
                align-items: center;
                color: rgb(44, 44, 44);
                font-family: Source Han Sans;
                font-size: 16px;
                font-weight: 500;
                line-height: 16px;
                letter-spacing: 0px;
                margin-bottom: 8px;
                margin-top: 12px;
                span{
                    color: #EB2934;
                    margin-right: 4px;
                }
            }
            :deep(.el-select__wrapper){
                min-height: 36px;
            }
        }
        .content-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-top: 40px;
            :deep(.el-button){
                width: 180px;
                height: 54px;
                color: rgb(255, 255, 255);
                font-family: Source Han Sans;
                font-size: 20px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 10px;
            }
        }
    }
    :deep(.el-checkbox__input.is-checked+.el-checkbox__label){
        color: #606266;
    }
}
</style>